<template>
    <v-dialog
        v-model="dialog"
        @click:outside="closeDialog"
        max-width="600px"
        scrollable
        zIndex="210"
    >
        <v-card>
            <sales-deal ref="salesDeal"></sales-deal>
            <letting-deal ref="lettingDeal"></letting-deal>
            <sub-letting-deal ref="subLettingDeal"></sub-letting-deal>
            <v-toolbar dense :elevation="0">
                <h2 class="text-h6 text-primary-700 text-ellipsis-overflow">
                    <span>Create Deal for </span>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <span v-on="on" class="text-dashed-underline ">{{ entity ? formatLabel(entity.label) : 'Enquiry' }}</span>
                        </template>
                        <span>{{ entity ? entity.label : '' }}</span>
                    </v-tooltip>
                </h2>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="py-4 px-8">
                <v-row class="ma-0" v-if="type == 'property'" justify="center">
                    <!-- button to route to either new letting or subletting deals with entity -->
                    <v-col cols="4" class="text-center" v-if="property && property.scheme_id">
                        <v-btn
                            outlined
                            :elevation="0"
                            class="button-panel"
                            @click="salesDeal"
                            color="grey darken-2"
                        >
                            <div class="text-center mt-4">
                                <v-icon>mdi-handshake</v-icon>
                                <p class="mt-2">Sale</p>
                            </div>
                        </v-btn>
                    </v-col> 
                    <v-col cols="4" class="text-center">
                        <v-btn
                            outlined
                            :elevation="0"
                            class="button-panel"
                            @click="lettingDeal"
                            color="grey darken-2"
                        >
                            <div class="text-center mt-4">
                                <v-icon>mdi-handshake</v-icon>
                                <p class="mt-2">Letting</p>
                            </div>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="text-center">
                        <v-btn
                            outlined
                            :elevation="0"
                            class="button-panel"
                            @click="subLettingDeal"
                            color="grey darken-2"
                        >
                            <div class="text-center mt-4">
                                <v-icon>mdi-handshake</v-icon>
                                <p class="mt-2">Sub-Letting /<br/>Assignment</p>
                            </div>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="ma-0" v-else>
                    <!-- button to route to new sales deal with entity -->
                    <v-col cols="4" class="text-center">
                        <v-btn
                            outlined
                            :elevation="0"
                            class="button-panel"
                            @click="salesDeal"
                            color="grey darken-2"
                        >
                            <div class="text-center mt-4">
                                <v-icon>mdi-handshake</v-icon>
                                <p class="mt-2">Sales</p>
                            </div>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="text-center">
                        <v-btn
                            outlined
                            :elevation="0"
                            class="button-panel"
                            @click="lettingDeal"
                            color="grey darken-2"
                        >
                            <div class="text-center mt-4">
                                <v-icon>mdi-handshake</v-icon>
                                <p class="mt-2">Letting</p>
                            </div>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" class="text-center">
                        <v-btn
                            outlined
                            :elevation="0"
                            class="button-panel"
                            @click="subLettingDeal"
                            color="grey darken-2"

                        >
                            <div class="text-center mt-4">
                                <v-icon>mdi-handshake</v-icon>
                                <p class="mt-2">Sub-Letting /<br/>Assignment</p>
                            </div>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    @click="closeDialog"
                >
                    Close
                </v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>

<script>
    import SalesDeal from '@/components/deals/saleDealWizard.vue'
    import LettingDeal from '@/components/deals/newLettingDealWizard.vue'
    import SubLettingDeal from '@/components/deals/subLettingDealWizard.vue'
import { property } from 'lodash';
    export default {
        components: {
            SalesDeal,
            LettingDeal,
            SubLettingDeal,
        },
        data() {
            return {
                dialog: false,
                enquiry: null,
                entity: null,
                type: null,
                property: null,
            }
        },
        methods: {
            closeDialog() {
                this.dialog = false;
            },
            openDialog(entity, property, scheme) {
                this.enquiry = entity;

                if (property){
                    this.type = 'property';
                    this.entity = property;
                    this.getPropertyData();
                }else{
                    this.type = 'scheme';
                    this.entity = scheme;
                    this.dialog = true;
                }
            },

            formatLabel(value) {
                // split by - and take first part
                return value.split('-')[0]
            },

            salesDeal() {
                if(this.type == 'scheme'){
                    this.$refs.salesDeal.showDialog({
                        scheme_id: this.entity.value, 
                        name: this.entity.label
                    });
                    this.dialog = false;
                }else{
                    this.$refs.salesDeal.showDialog({
                        property_id: this.entity.value,
                        name: this.entity.label
                    });
                    this.dialog = false;
                }
            },

            getPropertyData() {
                this.$http.get(`/properties/${this.entity.value}`)
                    .then(response => {
                        this.property = response.data;
                        console.log(this.property);
                        this.dialog = true;
                    })
                    .catch(error => {
                        console.log(error);
                    });
            },

            lettingDeal() {
                console.log('opening letting',this.entity);
                if(this.type == 'property'){
                    this.$refs.lettingDeal.showDialog({
                        property_id: this.entity.value,
                        name: this.entity.label
                    });
                    this.dialog = false;
                }else{
                    this.$refs.lettingDeal.showDialog();
                    this.dialog = false;
                }
            },
            subLettingDeal() {
                if(this.type == 'property'){
                    this.$refs.subLettingDeal.showDialog({
                        property_id: this.entity.value,
                        name: this.entity.label
                    });
                    this.dialog = false;
                }else{
                    this.$refs.subLettingDeal.showDialog();
                    this.dialog = false;
                }
            },
        }
    }
</script>